function App() {
  return (
    <main className="closing">
      <div className="closing-logo">Agentademia</div>
      <p className="closing-message">
        Agentademia has closed. Thank you to everyone who tried it.
      </p>
    </main>
  );
}

export default App;
